import React from 'react';
import { Link } from 'react-router'

let config = require('config');

class Member extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    const { actions, data } = this.props;
    if (data.member == null) {
      actions.getMember()
    }
  }

  render() {
    const { actions, data } = this.props;
    var members = data.member;
    document.title = "MEMBER | " + config.default.SITE_NAME
    return (
      <div id="member" className="main">
        <div className="member_inner">
          { members ?
              <div className="member_list">
                { members.contents.map(function(member, i) {
                  return (
                    <div key={i} className="member_list__block">
                      <Link to={"/member/" + member.id + "/"}>
                        <div className="block__name_jp">{member.name}</div>
                        <div className="block__name_en">{member.name_en}</div>
                        <div className="block__name_title">{member.position}</div>
                      </Link>
                    </div>
                  )
                })}
              </div>
            :null
          }
        </div>
      </div>
    );
  }
}

Member.displayName = 'Member';
Member.propTypes = {};
Member.defaultProps = {};

export default Member;



// WEBPACK FOOTER //
// ./components/Member.js